export const Notifications = (api) => ({
  alarms: {
    count() {
      return api.get('/v1/notifications/alerts/count')
    }
  },
  list({ show_only_unviewed } = {}) {
    return api.get('/v1/notifications', {
      params: {
        show_only_unviewed
      }
    })
  },
  view(notifications) {
    return api.put('/v1/notifications/view', { notifications })
  }
})
